import { RIcon } from './RIcon';

type Props = {
  title: string;
  on?: boolean;
  onClick?: () => void;
  desc?: string;
  radio?: boolean;
  dashed?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  describedBy?: string;
  id?: string;
};

const ROpt = ({
  title,
  on,
  onClick,
  desc,
  radio,
  dashed,
  disabled,
  invalid,
  describedBy,
  id,
}: Props) => (
  <button
    id={id}
    type="button"
    className={['c-checkopt', on ? 'on' : '', radio ? 'c-checkopt-radio' : '', dashed ? 'dashed' : '', invalid ? 'is-invalid' : '']
      .filter(Boolean)
      .join(' ')}
    role={radio ? 'radio' : 'checkbox'}
    aria-checked={!!on}
    aria-invalid={invalid || undefined}
    aria-describedby={describedBy}
    disabled={disabled}
    onClick={() => onClick?.()}
  >
    <span className="c-checkopt-box">
      <RIcon.check />
    </span>
    <span className="c-checkopt-body">
      <span className="c-checkopt-title">{title}</span>
      {desc && <span className="c-checkopt-desc">{desc}</span>}
    </span>
  </button>
);

export { ROpt };
